<template>
  <div class="verb-practice">
    <h1>Nomen-Verb-Verbindungen</h1>
    
<div class="progress-container">
  <div class="progress-bar">
    <div class="progress-fill" :style="{ width: progressPercentage + '%' }"></div>
  </div>
<p class="progress-text">Kérdés: {{ displayIndex }} / {{ totalQuestionsInRound }}</p>
</div>

    <div v-if="currentQuestion && !showStatistics" class="quiz-area">
      <div class="question-card">
        <h2 class="nomen-display">{{ currentQuestion.nomen }} ...</h2>
        <p class="meaning">({{ currentQuestion.meaning }})</p>
      </div>

      <div class="input-wrapper">
        <input
          type="text"
          v-model="userAnswer"
          placeholder="Írd be az igét..."
          :disabled="isAnswered"
          @keyup.enter="handleEnter"
          ref="answerInput"
          :class="{ 'input-correct': isAnswered && isCorrect, 'input-wrong': isAnswered && isCorrect === false }"
        />
        <span v-if="isAnswered && isCorrect" class="input-icon correct-icon">✓</span>
        <span v-if="isAnswered && isCorrect === false" class="input-icon wrong-icon">✗</span>
      </div>
      
      <div class="button-group">
        <button v-if="!isAnswered" @click="checkAnswer" class="btn-check" :disabled="!userAnswer.trim()">Ellenőrzés</button>
        <button v-if="isAnswered" @click="nextQuestion" class="btn-next">Következő</button>
      </div>

      <transition name="fade">
        <div v-if="feedback" :class="['feedback-box', isCorrect ? 'fb-correct' : 'fb-wrong']">
          <p v-if="!isCorrect" class="wrong-highlight">Helyes válasz: <span>{{ currentQuestion.verb }}</span></p>
          <p class="feedback-text">{{ feedback }}</p>
          
          <div class="example-box">
            <div class="german-example">
              <strong>Beispiel:</strong>
              <p>{{ currentQuestion.example }}</p>
            </div>
            <div class="hungarian-translation">
              <strong>Magyarul:</strong>
              <p>{{ currentQuestion.translation }}</p>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <div v-if="showStatistics" class="popup-overlay">
      <div class="popup-content">
        <h2>Kör vége</h2>
        <div class="stats-summary">
          <p>Helyes: <span class="correct-text">{{ correctAnswersInRound }}</span> | Helytelen: <span class="wrong-text">{{ incorrectAnswersInRound }}</span></p>
        </div>
        <p v-if="incorrectAnswersInRound === 0" class="success-msg">🌟 Hibátlan! Jöhet a következő 10!</p>
        <p v-else class="fail-msg">❌ Volt benne hiba. Ismételjük meg ezt a kört!</p>
        
        <div class="solved-list">
          <div v-for="(item, i) in roundHistory" :key="i" :class="['history-item', item.isCorrect ? 'h-correct' : 'h-wrong']">
            <strong>{{ item.nomen }}</strong> {{ item.isCorrect ? '✓' : '✗' }} ({{ item.correctAnswer }})
          </div>
        </div>
        <button @click="startNextAction" class="btn-popup-action">Indítás</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NomenVerbPractice",
  data() {
    return {
      // PDF-ALAPJÁN FELTÖLTÖTT TELJES LISTA
     allVerbs: [
  { nomen: "einen Vertrag", verb: "abschließen", meaning: "einen Vertrag unterschreiben", example: "Gestern habe ich einen Vertrag mit einem neuen Kunden abgeschlossen.", translation: "Tegnap szerződést kötöttem egy új ügyféllel." },
  { nomen: "ein Thema", verb: "anschneiden", meaning: "beginnen, über etwas zu sprechen", example: "Ich würde gerne noch ein Thema anschneiden, das mir sehr wichtig ist.", translation: "Szeretnék még egy témát felvetni, ami nagyon fontos nekem." },
  { nomen: "die Hoffnung", verb: "aufgeben", meaning: "aufhören, zu hoffen", example: "Als Petra die Hoffnung fast aufgegeben hatte, hat sie Peter kennengelernt.", translation: "Amikor Petra már majdnem feladta a reményt, megismerte Petert." },
  { nomen: "Kontakt", verb: "aufnehmen", meaning: "jemanden kontaktieren", example: "Haben Sie schon mit Frau Müller Kontakt aufgenommen?", translation: "Felvette már a kapcsolatot Müller asszonnyal?" },
  { nomen: "einen Beruf", verb: "ausüben", meaning: "in einem Beruf arbeiten", example: "Menschen, die einen Beruf ausüben, der ihnen Spaß macht, sind oft glücklich.", translation: "Azok az emberek, akik olyan szakmát gyakorolnak, amit élveznek, gyakran boldogok." },
  { nomen: "eine Enttäuschung", verb: "bereiten", meaning: "jemanden enttäuschen", example: "Es hat mir eine große Enttäuschung bereitet, dass meine Freunde nicht kamen.", translation: "Nagy csalódást okozott nekem, hogy a barátaim nem jöttek el." },
  { nomen: "Freude", verb: "bereiten", meaning: "jemanden freuen", example: "Frische Blumen in meiner Wohnung bereiten mir große Freude.", translation: "A friss virágok a lakásomban nagy örömet okoznak nekem." },
  { nomen: "in Bewegung", verb: "bringen", meaning: "anfangen, etwas zu bewegen", example: "Eine Sammelaktion hat viel in Bewegung gebracht.", translation: "Egy gyűjtési akció sok mindent mozgásba hozott." },
  { nomen: "in Ordnung", verb: "bringen", meaning: "etwas ordnen/korrigieren", example: "Ich verspreche, dass ich das wieder in Ordnung bringe.", translation: "Ígérem, hogy ezt újra rendbe hozom." },
  { nomen: "in Schwierigkeiten", verb: "bringen", meaning: "jemandem Probleme machen", example: "Ich wollte dich nicht in Schwierigkeiten bringen.", translation: "Nem akartalak bajba sodorni." },
  { nomen: "in Verlegenheit", verb: "bringen", meaning: "jemanden verlegen machen", example: "Mit diesem Kompliment bringst du mich in Verlegenheit.", translation: "Ezzel a bókkal zavarba hozol." },
  { nomen: "unter Kontrolle", verb: "bringen", meaning: "etwas kontrollieren", example: "Wir müssen alles wieder unter Kontrolle bringen.", translation: "Mindent újra ellenőrzés alá kell vonnunk." },
  { nomen: "zu Ende", verb: "bringen", meaning: "beenden", example: "Es wird Zeit, dass wir dieses Projekt zu Ende bringen.", translation: "Itt az ideje, hogy befejezzük ezt a projektet." },
  { nomen: "zum Abschluss", verb: "bringen", meaning: "abschließen", example: "Ich möchte dieses Projekt endlich zum Abschluss bringen.", translation: "Szeretném ezt a projektet végre lezárni." },
  { nomen: "zum Ausdruck", verb: "bringen", meaning: "etwas ausdrücken", example: "Ich möchte damit zum Ausdruck bringen, dass mir das nicht gefällt.", translation: "Szeretném kifejezésre juttatni, hogy ez nem tetszik nekem." },
  { nomen: "zur Sprache", verb: "bringen", meaning: "ein Thema ansprechen", example: "Ich finde es gut, dass du dieses Thema zur Sprache gebracht hast.", translation: "Jónak tartom, hogy szóba hoztad ezt a témát." },
  { nomen: "zur Vernunft", verb: "bringen", meaning: "jemanden vernünftig machen", example: "Kannst du deinen Bruder bitte zur Vernunft bringen?", translation: "Észhez tudnád téríteni a testvéredet, kérlek?" },
  { nomen: "zur Verzweiflung", verb: "bringen", meaning: "jemanden aufregen", example: "Das alles bringt mich zur Verzweiflung.", translation: "Ez az egész kétségbeesésbe kerget." },
  { nomen: "Verbesserungen", verb: "durchführen", meaning: "verbessern", example: "An dem Produkt müssen Verbesserungen durchgeführt werden.", translation: "A terméken javításokat kell eszközölni." },
  { nomen: "eine Pflicht", verb: "erfüllen", meaning: "seine Aufgaben machen", example: "Als Elternteil muss man viele Pflichten erfüllen.", translation: "Szülőként sok kötelességet kell teljesíteni." },
  { nomen: "das Wort", verb: "ergreifen", meaning: "beginnen zu sprechen", example: "Bei der Konferenz hatte ich keine Chance, das Wort zu ergreifen.", translation: "A konferencián nem volt esélyem magamhoz ragadni a szót." },
  { nomen: "Maßnahmen", verb: "ergreifen", meaning: "handeln", example: "Die Stadtregierung muss Maßnahmen dagegen ergreifen.", translation: "A városvezetésnek intézkedéseket kell tennie ez ellen." },
  { nomen: "eine Niederlage", verb: "erleiden", meaning: "verlieren/scheitern", example: "Der FC Bayern hat eine Niederlage erlitten.", translation: "A Bayern München vereséget szenvedett." },
  { nomen: "Auskunft", verb: "erteilen", meaning: "jemanden informieren", example: "Am Schalter wird Ihnen Auskunft erteilt.", translation: "A pultnál tájékoztatást adnak Önnek." },
  { nomen: "einen Auftrag", verb: "erteilen", meaning: "jemanden beauftragen", example: "Wir erteilen der Firma einen Auftrag.", translation: "Megbízást adunk a cégnek." },
  { nomen: "in Ohnmacht", verb: "fallen", meaning: "ohnmächtig werden", example: "Mir war so schwindlig, ich bin in Ohnmacht gefallen.", translation: "Úgy szédültem, hogy elájultam." },
  { nomen: "zur Last", verb: "fallen", meaning: "jemandem lästig werden", example: "Meine Freundin möchte niemandem zur Last fallen.", translation: "A barátnőm nem akar senkinek a terhére lenni." },
  { nomen: "eine Entscheidung", verb: "fällen", meaning: "sich entscheiden", example: "Wir haben endlich eine Entscheidung gefällt.", translation: "Végre döntést hoztunk." },
  { nomen: "einen Beschluss", verb: "fassen", meaning: "beschließen", example: "Die Regierung fasst den Beschluss, ein Gesetz zu verfassen.", translation: "A kormány határozatot hoz egy törvény megalkotásáról." },
  { nomen: "einen Entschluss", verb: "fassen", meaning: "sich entschließen", example: "Meine Schwester hat den Entschluss gefasst, den Job zu wechseln.", translation: "A nővérem elhatározta, hogy munkahelyet vált." },
  { nomen: "Beachtung", verb: "finden", meaning: "beachtet werden", example: "Die Ergebnisse fanden weltweit Beachtung.", translation: "Az eredmények világszerte figyelmet kaptak." },
  { nomen: "Berücksichtigung", verb: "finden", meaning: "berücksichtigt werden", example: "Unsere Bitten finden keine Berücksichtigung.", translation: "Kéréseinket nem veszik figyelembe." },
  { nomen: "eine Lösung", verb: "finden", meaning: "ein Problem lösen", example: "Wir finden bestimmt eine Lösung!", translation: "Biztosan találunk megoldást!" },
  { nomen: "Gefallen", verb: "finden", meaning: "gefallen", example: "Langsam finde ich Gefallen am Gitarrespielen.", translation: "Lassan kedvemet lelem a gitározásban." },
  { nomen: "Interesse", verb: "finden", meaning: "beginnen sich zu interessieren", example: "Letztes Jahr habe ich Interesse an Kunst gefunden.", translation: "Tavaly elkezdett érdekelni a művészet." },
  { nomen: "eine Ehe", verb: "führen", meaning: "verheiratet sein", example: "Meine Großeltern führen eine harmonische Ehe.", translation: "A nagyszüleim harmonikus házasságban élnek." },
  { nomen: "einen Kampf", verb: "führen", meaning: "kämpfen", example: "Ich führe einen Kampf gegen meinen inneren Schweinehund.", translation: "Harcot vívok a belső lustaságom ellen." },
  { nomen: "ein Gespräch", verb: "führen", meaning: "sich unterhalten", example: "Mit Freunden kann ich stundenlange Gespräche führen.", translation: "A barátokkal órákig tudok beszélgetni." },
  { nomen: "die Erlaubnis", verb: "geben", meaning: "erlauben", example: "Natalia gibt ihren Kindern die Erlaubnis.", translation: "Natália megadja az engedélyt a gyerekeinek." },
  { nomen: "die Garantie", verb: "geben", meaning: "garantieren", example: "Ich gebe dir die Garantie, dass ich da bin.", translation: "Garantálom neked, hogy ott leszek." },
  { nomen: "eine Antwort", verb: "geben", meaning: "antworten", example: "Kannst du mir eine Antwort geben?", translation: "Tudsz nekem választ adni?" },
  { nomen: "einen Hinweis", verb: "geben", meaning: "auf etwas hinweisen", example: "Die Polizei sucht Zeugen, die einen Hinweis geben können.", translation: "A rendőrség tanúkat keres, akik nyomot tudnak adni." },
  { nomen: "einen Rat", verb: "geben", meaning: "etwas raten", example: "Mein Opa hat mir oft einen guten Rat gegeben.", translation: "A papám gyakran adott nekem jó tanácsot." },
  { nomen: "in Auftrag", verb: "geben", meaning: "produzieren lassen", example: "Sie gibt die Tasse auf einer Website in Auftrag.", translation: "Megrendeli a bögrét egy weboldalon." },
  { nomen: "sich Mühe", verb: "geben", meaning: "sich bemühen", example: "Ich habe mir viel Mühe beim Malen gegeben.", translation: "Sok fáradságot fektettem a festésbe." },
  { nomen: "auf die Nerven", verb: "gehen", meaning: "nervig sein", example: "Es geht mir auf die Nerven, dass mein Nachbar Trompete spielt.", translation: "Az idegeimre megy, hogy trombitál." },
  { nomen: "in Erfüllung", verb: "gehen", meaning: "sich erfüllen", example: "Ein großer Wunsch ist in Erfüllung gegangen.", translation: "Egy nagy kívánság teljesült." },
  { nomen: "zu Ende", verb: "gehen", meaning: "enden", example: "Auch die schönen Dinge gehen zu Ende.", translation: "A szép dolgok is véget érnek egyszer." },
  { nomen: "Anspruch", verb: "haben", meaning: "etwas beanspruchen", example: "Jeder hat einen Anspruch auf einen Arbeitsplatz.", translation: "Mindenkinek joga van egy munkahelyhez." },
  { nomen: "Auswirkungen", verb: "haben", meaning: "sich auswirken", example: "Schlafmangel hat Auswirkungen auf die Konzentration.", translation: "Az alváshiány hatással van a koncentrációra." },
  { nomen: "Hoffnung", verb: "haben", meaning: "hoffen", example: "Ich habe die Hoffnung, dass ich mehr Urlaub machen kann.", translation: "Remélem, hogy több szabadságot tudok kivenni." },
  { nomen: "Verdacht", verb: "haben", meaning: "verdächtigen", example: "Ich habe den Verdacht, dass er heimlich meine Süßigkeiten isst.", translation: "Azt gyanítom, hogy eszi az édességemet." },
  { nomen: "die Absicht", verb: "haben", meaning: "etwas beabsichtigen", example: "Sie hat die Absicht, ihrem Sohn ein Auto zu schenken.", translation: "Szándékában áll autót ajándékozni a fiának." },
  { nomen: "eine Ahnung", verb: "haben", meaning: "etwas wissen/vermuten", example: "Ich bin mir nicht sicher, aber ich habe eine Ahnung.", translation: "Nem vagyok biztos benne, de van egy sejtésem." },
  { nomen: "Einfluss", verb: "haben", meaning: "beeinflussen", example: "Mein Lehrer hatte großen Einfluss auf mich.", translation: "A tanárom nagy hatással volt rám." },
  { nomen: "ein Recht", verb: "haben", meaning: "berechtigt sein", example: "Man hat ein Recht auf faire Bedingungen.", translation: "Jogunk van a tisztességes feltételekhez." },
  { nomen: "Interesse", verb: "haben", meaning: "sich interessieren für", example: "Karla hat großes Interesse an Pflanzen.", translation: "Karla nagy érdeklődést mutat a növények iránt." },
  { nomen: "zur Folge", verb: "haben", meaning: "etwas bewirken", example: "Zu wenig Lernen hat oft zur Folge, dass man durchfällt.", translation: "A kevés tanulás gyakran azt vonja maga után, hogy megbukik az ember." },
  { nomen: "Abstand", verb: "halten", meaning: "entfernt bleiben", example: "Auf der Autobahn muss man Abstand halten.", translation: "Az autópályán távolságot kell tartani." },
  { nomen: "eine Rede", verb: "halten", meaning: "vor Publikum sprechen", example: "Der Bürgermeister hält eine Rede.", translation: "A polgármester beszédet tart." },
  { nomen: "ein Versprechen", verb: "halten", meaning: "etwas Versprochenes machen", example: "Mein Vater hat sein Versprechen gehalten.", translation: "Apukám betartotta az ígéretét." },
  { nomen: "in Ordnung", verb: "halten", meaning: "etwas pflegen", example: "Lena möchte ihre Wohnung in Ordnung halten.", translation: "Lena rendben akarja tartani a lakását." },
  { nomen: "sein Wort", verb: "halten", meaning: "sich an Versprochenes halten", example: "Er hat sein Wort gehalten und den Schrank aufgebaut.", translation: "Tartotta a szavát és összerakta a szekrényt." },
  { nomen: "einen Eindruck", verb: "hinterlassen", meaning: "jemanden beeindrucken", example: "Hoffentlich habe ich einen guten Eindruck hinterlassen.", translation: "Remélhetőleg jó benyomást hagytam." },
  { nomen: "infrage", verb: "kommen", meaning: "relevant/möglich sein", example: "Das kommt gar nicht infrage!", translation: "Ez szóba sem jöhet!" },
  { nomen: "in Gang", verb: "kommen", meaning: "aktiv werden", example: "Die Maschine kommt wieder in Gang.", translation: "A gép újra beindul." },
  { nomen: "zu einer Entscheidung", verb: "kommen", meaning: "etwas entscheiden", example: "Wir müssen zu einer Entscheidung kommen.", translation: "Döntésre kell jutnunk." },
  { nomen: "zu Hilfe", verb: "kommen", meaning: "jemandem helfen", example: "Ich komme dir gerne zu Hilfe.", translation: "Szívesen sietek a segítségedre." },
  { nomen: "zu Ohren", verb: "kommen", meaning: "etwas hören/erfahren", example: "Mir ist zu Ohren gekommen, dass Anna kündigen will.", translation: "Fülembe jutott, hogy Anna fel akar mondani." },
  { nomen: "zu Wort", verb: "kommen", meaning: "reden können", example: "Ich komme kaum zu Wort, alle reden.", translation: "Alig jutok szóhoz, mindenki beszél." },
  { nomen: "zum Schluss", verb: "kommen", meaning: "beenden", example: "Damit kommen wir zum Schluss der Stunde.", translation: "Ezzel az óra végéhez érünk." },
  { nomen: "zur Ruhe", verb: "kommen", meaning: "ruhig werden", example: "Am Wochenende bin ich zur Ruhe gekommen.", translation: "Hétvégén végre megnyugodtam." },
  { nomen: "zur Sprache", verb: "kommen", meaning: "besprochen werden", example: "Das Thema ist zur Sprache gekommen.", translation: "A téma szóba került." },
  { nomen: "zur Vernunft", verb: "kommen", meaning: "vernünftig werden", example: "Hoffentlich kommt sie bald wieder zur Vernunft.", translation: "Remélhetőleg hamar megjön az esze." },
  { nomen: "im Stich", verb: "lassen", meaning: "alleine lassen", example: "Ich lasse dich nicht im Stich.", translation: "Nem hagylak cserben." },
  { nomen: "in Ruhe", verb: "lassen", meaning: "jemanden nicht stören", example: "Bitte lass mich in Ruhe.", translation: "Kérlek, hagyj békén." },
  { nomen: "Wert", verb: "legen", meaning: "wichtig sein", example: "Mein Chef legt Wert auf Pünktlichkeit.", translation: "A főnököm ad a pontosságra." },
  { nomen: "Gesellschaft", verb: "leisten", meaning: "jemanden begleiten", example: "Möchtest du mir Gesellschaft leisten?", translation: "Szeretnél nekem társaságot nyújtani?" },
  { nomen: "Hilfe", verb: "leisten", meaning: "helfen", example: "Man muss Hilfe leisten.", translation: "Segítséget kell nyújtani." },
  { nomen: "auf der Hand", verb: "liegen", meaning: "offensichtlich sein", example: "Es liegt auf der Hand, dass er überfordert ist.", translation: "Kézenfekvő, hogy túlterhelt." },
  { nomen: "den Anfang", verb: "machen", meaning: "anfangen", example: "Irgendjemand muss den Anfang machen.", translation: "Valakinek el kell kezdenie." },
  { nomen: "eine Andeutung", verb: "machen", meaning: "andeuten", example: "Er hat eine Andeutung gemacht.", translation: "Tett egy utalást." },
  { nomen: "einen Vorwurf", verb: "machen", meaning: "jemandem etwas vorwerfen", example: "Ich mache dir keinen Vorwurf.", translation: "Nem szemrehányást teszek neked." },
  { nomen: "Gebrauch", verb: "machen", meaning: "etwas gebrauchen", example: "Ich mache von meinem Widerrufsrecht Gebrauch.", translation: "Élek az elállási jogommal." },
  { nomen: "sich Gedanken", verb: "machen", meaning: "nachdenken über", example: "Ich habe mir viele Gedanken über meine Zukunft gemacht.", translation: "Gondolkodom a jövőn." },
  { nomen: "Abschied", verb: "nehmen", meaning: "sich verabschieden", example: "Man nimmt Abschied von Verstorbenen.", translation: "Búcsút veszünk az elhunytaktól." },
  { nomen: "in Betrieb", verb: "nehmen", meaning: "etwas starten", example: "Morgen wird die Maschine in Betrieb genommen.", translation: "Holnap üzembe helyezik a gépet." },
  { nomen: "in Empfang", verb: "nehmen", meaning: "empfangen", example: "Sie nehmen die Gäste in Empfang.", translation: "Fogadják a vendégeket." },
  { nomen: "in Kauf", verb: "nehmen", meaning: "Negatives akzeptieren", example: "Man nimmt es in Kauf, auch am Wochenende zu arbeiten.", translation: "Belenyugszik az ember, hogy hétvégén is dolgozik." },
  { nomen: "in Schutz", verb: "nehmen", meaning: "verteidigen", example: "Meine Mutter hat mich in Schutz genommen.", translation: "Anyukám a védelmébe vett." },
  { nomen: "Rücksicht", verb: "nehmen", meaning: "berücksichtigen", example: "Wir nehmen Rücksicht auf die Nachbarn.", translation: "Tekintettel vagyunk a szomszédokra." },
  { nomen: "Stellung", verb: "nehmen", meaning: "die eigene Meinung sagen", example: "Der Politiker nimmt Stellung zu den Vorwürfen.", translation: "A politikus állást foglal a vádakkal kapcsolatban." },
  { nomen: "einen Kompromiss", verb: "schließen", meaning: "sich einigen", example: "Manchmal muss man einen Kompromiss schließen.", translation: "Kompromisszumot kell kötni." },
  { nomen: "Freundschaft", verb: "schließen", meaning: "sich anfreunden", example: "Ich habe mit meiner Nachbarin Freundschaft geschlossen.", translation: "Barátságot kötöttem." },
  { nomen: "Frieden", verb: "schließen", meaning: "sich vertragen", example: "Heute haben wir endlich Frieden geschlossen.", translation: "Ma békét kötöttünk." },
  { nomen: "am Ende", verb: "sein", meaning: "keine Kraft mehr haben", example: "Ich bin total am Ende.", translation: "Teljesen végem van / kimerültem." },
  { nomen: "außer Atem", verb: "sein", meaning: "erschöpft sein", example: "Puh, ich bin total außer Atem.", translation: "Hű, teljesen kifogytam a szuszból." },
  { nomen: "der Meinung", verb: "sein", meaning: "etwas meinen", example: "Mein Vater ist der Meinung, dass sie zu wenig lernt.", translation: "Apám azon a véleményen van, hogy keveset tanul." },
  { nomen: "im Einsatz", verb: "sein", meaning: "eingesetzt sein", example: "Mein Bruder ist oft im Einsatz.", translation: "A bátyám gyakran van bevetésen." },
  { nomen: "in Betrieb", verb: "sein", meaning: "laufen/funktionieren", example: "Die Maschine ist in Betrieb.", translation: "A gép üzemel." },
  { nomen: "in der Lage", verb: "sein", meaning: "fähig sein", example: "Ich bin nicht in der Lage, heute etwas Anstrengendes zu machen.", translation: "Nem vagyok abban a helyzetben / nem vagyok képes rá." },
  { nomen: "in Kraft", verb: "sein", meaning: "gültig sein", example: "Das Gesetz ist seit gestern in Kraft.", translation: "A törvény hatályban van." },
  { nomen: "von Bedeutung", verb: "sein", meaning: "bedeutend sein", example: "Das ist von großer Bedeutung für mich.", translation: "Ez nagy jelentőséggel bír számomra." },
  { nomen: "in Gang", verb: "setzen", meaning: "etwas starten", example: "Die Maschine wird wieder in Gang gesetzt.", translation: "A gépet mozgásba hozzák / beindítják." },
  { nomen: "in Kenntnis", verb: "setzen", meaning: "informieren", example: "Wir setzen Sie hiermit in Kenntnis.", translation: "Ezúton tájékoztatjuk Önt." },
  { nomen: "in Verbindung", verb: "setzen", meaning: "kontaktieren", example: "Setzen Sie sich mit Herrn Huber in Verbindung.", translation: "Vegye fel a kapcsolatot Huber úrral." },
  { nomen: "zum Ziel", verb: "setzen", meaning: "etwas anstreben", example: "Ich setze mir zum Ziel, mehr Sport zu machen.", translation: "Azt a célt tűzöm ki magam elé, hogy sportoljak." },
  { nomen: "unter Druck", verb: "setzen", meaning: "jemanden bedrängen", example: "Der Termin setzt mich ziemlich unter Druck.", translation: "A határidő nyomás alá helyez." },
  { nomen: "eine Rolle", verb: "spielen", meaning: "wichtig sein", example: "Freunde spielen eine große Rolle.", translation: "A barátok nagy szerepet játszanak." },
  { nomen: "im Gegensatz", verb: "stehen", meaning: "entgegengesetzt sein", example: "Zucker steht im Gegensatz zu gesunder Ernährung.", translation: "A cukor ellentétben áll az egészséges táplálkozással." },
  { nomen: "in Konkurrenz", verb: "stehen", meaning: "konkurrieren", example: "Die Bäckerei steht in Konkurrenz.", translation: "A pékség versenyben áll." },
  { nomen: "in Verbindung", verb: "stehen", meaning: "Kontakt haben", example: "Ich stehe mit meinen Kunden in Verbindung.", translation: "Kapcsolatban állok az ügyfelekkel." },
  { nomen: "in Widerspruch", verb: "stehen", meaning: "widersprüchlich sein", example: "Das steht im Widerspruch zu meiner Erinnerung.", translation: "Ez ellentmond az emlékezetemnek." },
  { nomen: "unter dem Einfluss", verb: "stehen", meaning: "beeinflusst werden", example: "Paula steht unter dem Einfluss von Freunden.", translation: "Paula a barátai befolyása alatt áll." },
  { nomen: "unter Druck", verb: "stehen", meaning: "bedrängt werden", example: "Ich stehe sehr unter Druck.", translation: "Nagy nyomás alatt állok." },
  { nomen: "zum Verkauf", verb: "stehen", meaning: "verkauft werden sollen", example: "Das Haus steht zum Verkauf.", translation: "A ház eladó." },
  { nomen: "zur Auswahl", verb: "stehen", meaning: "ausgewählt werden können", example: "Drei Kleider stehen zur Auswahl.", translation: "Három ruha áll rendelkezésre választáshoz." },
  { nomen: "zur Verfügung", verb: "stehen", meaning: "bereit stehen", example: "Waschmaschinen stehen zur Verfügung.", translation: "Mosógépek állnak rendelkezésre." },
  { nomen: "zur Wahl", verb: "stehen", meaning: "gewählt werden können", example: "Zwei Kandidaten stehen zur Wahl.", translation: "Két jelölt áll választásra." },
  { nomen: "auf die Probe", verb: "stellen", meaning: "jemanden testen", example: "Der Chef stellt den Praktikanten auf die Probe.", translation: "A főnök próbára teszi a gyakornokot." },
  { nomen: "eine Forderung", verb: "stellen", meaning: "fordern", example: "Er stellt nur Forderungen.", translation: "Csak követeléseket támaszt." },
  { nomen: "eine Frage", verb: "stellen", meaning: "fragen", example: "Darf ich eine Frage stellen?", translation: "Feltehetek egy kérdést?" },
  { nomen: "einen Antrag", verb: "stellen", meaning: "etwas beantragen", example: "Ich habe einen Antrag auf Wohngeld gestellt.", translation: "Benyújtottam egy kérelmet." },
  { nomen: "in Rechnung", verb: "stellen", meaning: "etwas berechnen", example: "Man stellt seine Arbeit in Rechnung.", translation: "Számlázzuk a munkánkat." },
  { nomen: "infrage", verb: "stellen", meaning: "anzweifeln", example: "Sabrina hat ihre Entscheidung infrage gestellt.", translation: "Mindent megkérdőjelezett." },
  { nomen: "zur Verfügung", verb: "stellen", meaning: "bereitstellen", example: "Laptops werden zur Verfügung gestellt.", translation: "Laptopokat bocsátanak rendelkezésre." },
  { nomen: "auf Ablehnung", verb: "stoßen", meaning: "abgelehnt werden", example: "Das Projekt stößt auf Ablehnung.", translation: "A projekt elutasításra talál." },
  { nomen: "auf Kritik", verb: "stoßen", meaning: "kritisiert werden", example: "Das Vorhaben stößt auf Kritik.", translation: "A terv kritikába ütközik." },
  { nomen: "eine Absprache", verb: "treffen", meaning: "etwas absprechen", example: "Wir sollten eine Absprache mit den Kollegen treffen.", translation: "Megállapodást / egyeztetést kellene kötnünk." },
  { nomen: "eine Auswahl", verb: "treffen", meaning: "auswählen", example: "Wir müssen eine Auswahl treffen.", translation: "Választanunk kell." },
  { nomen: "eine Vereinbarung", verb: "treffen", meaning: "etwas vereinbaren", example: "Ich habe eine Vereinbarung getroffen.", translation: "Megállapodást kötöttem." },
  { nomen: "Vorbereitungen", verb: "treffen", meaning: "etwas vorbereiten", example: "Wir müssen Vorbereitungen treffen.", translation: "Előkészületeket kell tennünk." },
  { nomen: "in Kraft", verb: "treten", meaning: "gültig werden", example: "Das neue Gesetz tritt in Kraft.", translation: "A törvény hatályba lép." },
  { nomen: "Kritik", verb: "üben", meaning: "kritisieren", example: "Die Opposition übt heftige Kritik.", translation: "Az ellenzék kritikát gyakorol." },
  { nomen: "eine Meinung", verb: "vertreten", meaning: "eine Meinung haben", example: "Pia vertritt die Meinung, dass Naturmedizin besser ist.", translation: "Pia azt a véleményt képviseli, hogy..." },
  { nomen: "einen Standpunkt", verb: "vertreten", meaning: "von etwas überzeugt sein", example: "Emilia vertritt diesen Standpunkt.", translation: "Emilia képviseli az álláspontot." },
  { nomen: "Konsequenzen", verb: "ziehen", meaning: "aus etwas lernen", example: "Wir ziehen Konsequenzen aus der letzten Krise.", translation: "Levonjuk a következtetéseket a válságból." },
  { nomen: "Verständnis", verb: "zeigen", meaning: "etwas verstehen", example: "Meine Freundin zeigt immer sehr viel Verständnis.", translation: "Sok megértést mutat." }
],

      /// 🔥 ÚJ LOGIKA
      currentRoundQuestions: [],
      currentQuestionIndex: 0,

      roundHistory: [],
      currentQuestion: null,
      userAnswer: "",
      feedback: "",
      isAnswered: false,
      isCorrect: null,
      showStatistics: false,
      correctAnswersInRound: 0,
      incorrectAnswersInRound: 0,
      totalQuestionsInRound: 10
    };
  },

  created() {
    this.startRound();
  },

  computed: {
    progressPercentage() {
      return (this.roundHistory.length / this.totalQuestionsInRound) * 100;
    },
    displayIndex() {
      return Math.min(this.roundHistory.length + 1, this.totalQuestionsInRound);
    }
  },

  methods: {
    shuffle(array) {
      return [...array].sort(() => Math.random() - 0.5);
    },

    startRound() {
      this.roundHistory = [];
      this.correctAnswersInRound = 0;
      this.incorrectAnswersInRound = 0;
      this.showStatistics = false;

      // 👉 HA előző kör hibátlan volt → új 10
      // 👉 HA nem → ugyanaz marad
      if (this.currentRoundQuestions.length === 0) {
        this.currentRoundQuestions = this.shuffle(this.allVerbs).slice(0, this.totalQuestionsInRound);
      }

      this.currentQuestionIndex = 0;
      this.setNextQuestion();
    },

    setNextQuestion() {
      if (this.currentQuestionIndex === this.totalQuestionsInRound) {
        this.showStatistics = true;
        this.currentQuestion = null;
        return;
      }

      this.currentQuestion = this.currentRoundQuestions[this.currentQuestionIndex];
      this.currentQuestionIndex++;

      this.isAnswered = false;
      this.userAnswer = "";
      this.feedback = "";
      this.isCorrect = null;
    },

    checkAnswer() {
      if (this.isAnswered || !this.userAnswer.trim()) return;

      this.isAnswered = true;

      const userVal = this.userAnswer.trim().toLowerCase();
      const correctVal = this.currentQuestion.verb.toLowerCase();

      this.isCorrect = userVal === correctVal;

      if (this.isCorrect) {
        this.correctAnswersInRound++;
        this.feedback = "Richtig! ✓";
      } else {
        this.incorrectAnswersInRound++;
        this.feedback = "Falsch! ✗";
      }

      this.roundHistory.push({
        nomen: this.currentQuestion.nomen,
        userAnswer: this.userAnswer,
        correctAnswer: this.currentQuestion.verb,
        isCorrect: this.isCorrect
      });
    },

    handleEnter() {
      if (!this.isAnswered) {
        this.checkAnswer();
      } else {
        this.nextQuestion();
      }
    },

    nextQuestion() {
      this.setNextQuestion();
    },

    startNextAction() {
      if (this.incorrectAnswersInRound === 0) {
        // ✅ hibátlan → új kérdések
        this.currentRoundQuestions = [];
      }

      this.startRound();
    }
  }
};
</script>

<style scoped>
/* Alap konténer - kártya nélkül, középre igazítva */
.verb-practice {
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  padding: 20px;
  text-align: center;
  box-sizing: border-box;
  background: transparent;
}

h1 {
  color: #ffffff;
  font-size: 1.8rem;
  margin-bottom: 25px;
}

/* Haladási sáv - Pontosan 400px, mint a mezők */
.progress-container {
  width: 100%;
  max-width: 400px;
  margin: 0 auto 30px auto;
  box-sizing: border-box;
}

.progress-bar {
  width: 100%;
  height: 8px;
  background: rgba(224, 230, 237, 0.2);
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 8px;
}

.progress-fill {
  height: 100%;
  background: #2ecc71;
  transition: width 0.3s ease;
}

.progress-text {
  font-size: 0.9rem;
  color: #ffffff;
  margin: 0;
}

/* Kérdés kártya - Átlátszó */
.question-card {
  padding: 10px;
  margin-bottom: 25px;
}

.nomen-display {
  font-size: 2.2rem;
  color: #ffffff;
  margin: 0;
  font-weight: bold;
}

.meaning {
  font-style: italic;
  color: #bdc3c7;
  margin-top: 5px;
}

/* Beviteli mező és gombok egységes szélessége */
.input-wrapper, 
.button-group {
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
  position: relative;
  box-sizing: border-box;
}

input {
  width: 100%;
  padding: 15px 20px;
  border-radius: 50px;
  border: 2px solid rgba(223, 230, 233, 0.3);
  background: white;
  font-size: 18px;
  outline: none;
  transition: all 0.2s ease;
  box-sizing: border-box;
  margin-bottom: 15px;
  display: block;
}

input:focus {
  border-color: #3498db;
}

/* Helyes/Helytelen állapotok */
.input-correct {
  border-color: #2ecc71 !important;
  background-color: #eafaf1;
}
.input-wrong {
  border-color: #e74c3c !important;
  background-color: #fdf2f2;
}

.input-icon {
  position: absolute;
  right: 20px;
  top: 15px; /* Az input közepéhez igazítva */
  font-size: 20px;
  font-weight: bold;
}
.correct-icon { color: #2ecc71; }
.wrong-icon { color: #e74c3c; }

/* Gombok stílusa */
button {
  width: 100%;
  padding: 15px 35px;
  border-radius: 50px;
  border: none;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.2s ease;
  color: white;
  box-sizing: border-box;
  margin-bottom: 10px;
  display: block;
}

.btn-check {
  background: #2ecc71;
}
.btn-check:hover:not(:disabled) {
  background: #27ae60;
}

.btn-next {
  background: #3498db;
}
.btn-next:hover {
  background: #2980b9;
}

/* Visszajelző doboz és magyar fordítás */
.feedback-box {
  width: 100%;
  max-width: 400px;
  margin: 25px auto 0 auto;
  padding: 20px;
  border-radius: 15px;
  text-align: center;
  backdrop-filter: blur(5px);
  box-sizing: border-box;
}

.fb-correct {
  background-color: rgba(46, 204, 113, 0.2);
  border: 1px solid #2ecc71;
  color: #ffffff;
}
.fb-wrong {
  background-color: rgba(255, 255, 255, 0.1);
  border: 2px solid #e74c3c;
  color: #ffffff;
}

.wrong-highlight {
  background: #e74c3c;
  color: white;
  padding: 10px;
  border-radius: 10px;
  margin-bottom: 15px;
  font-weight: bold;
}

.hungarian-translation {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dotted rgba(255,255,255,0.3);
  color: #bdc3c7;
  font-style: italic;
}

/* Popup */
.popup-overlay {
  position: fixed;
  top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(0,0,0,0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.popup-content {
  background: white;
  padding: 40px;
  border-radius: 20px;
  width: 400px;
  text-align: center;
  color: #2c3e50;
}
.btn-popup-action {
  background: #2c3e50;
  width: 100%;
  margin-top: 20px;
}

.fade-enter-active, .fade-leave-active { transition: opacity 0.3s; }
.fade-enter-from, .fade-leave-to { opacity: 0; }
</style>